<script context="module">
  export function titleCase(str = "") {
    if (!str) return;
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  export function formatInt(num = null) {
    if (!num) return;
    try {
      return parseInt(num).toLocaleString("en-US");
    } catch (e) {
      console.error(e);
      return num;
    }
  }

  // Assumes 100% == 1, as far as input
  export function formatPercent(num = null, decimals = 0) {
    try {
      return Number(num).toLocaleString("en-US", { style: "percent", minimumFractionDigits: decimals });
    } catch (e) {
      console.error(e);
      return num;
    }
  }
</script>

<script>
  // COMPONENTS
  import Map from "./components/Map.svelte";
  import Timeline from "./components/Timeline.svelte";
  import Toggle from "./components/Toggle.svelte";

  import { afterUpdate, setContext } from "svelte";
  import { derived, writable } from "svelte/store";

  export let headline = "";
  export let chatter = "";
  export let sources = "";
  export let cabrini_label = "";
  export let race_toggle_label = "";

  const loading = writable(true);
  const currentYear = writable("1970");

  const races = ["Black", "White"];
  const currentRace = writable("black");
  const currentRaceDisplay = derived(currentRace, $currentRace => {
    return $currentRace === "black" ? titleCase($currentRace) : $currentRace;
  });

  setContext("bga-race", {
    loading,
    currentRace,
    currentRaceDisplay,
    currentYear,
    cabrini_label,
    races,
    formatInt,
    formatPercent,
  });

  function changeRace(e) {
    $currentRace = $currentRace === "black" ? "white" : "black";
  }
</script>

<!-- svelte-ignore a11y-structure -->
<figcaption>
  {#if headline}<h3>{headline}</h3>{/if}
  {#if chatter}{@html chatter}{/if}
</figcaption>
<Timeline start={1970} end={2020} step={10} />
<Toggle text={race_toggle_label} on:click={changeRace} />
<Map />
{#if sources}<span class="sources">{sources}</span>{/if}

<style>
  :global(html body #bga-race) {
    --fonts-serif: "georgia", serif;
    --fonts-sans: "Source Sans Pro", sans-serif;
    --touch-target: 44px;
    --color-text: #333333;
    --color-text-faded: #888;
    --color-background: white;
    --color-accent: #1a9b5b;
    --color-accent-text: white;
    --color-accent-faded: #22aa66;
  }

  @media all and (pointer: fine) {
    :global(html body #bga-race) {
      --touch-target: 33px;
    }
  }

  :global(html body #bga-race .bga-race-ui-label) {
    font: bold 14px/1.3em var(--fonts-sans);
    text-transform: uppercase;
    color: var(--color-text);
    text-align: center;
  }

  :global(html body #bga-race p) {
    font: 1em/1.3em var(--fonts-sans);
    margin: 1em 0;
    color: var(--color-text);
  }

  :global(html body #bga-race .race-popup p) {
    font-size: 18px;
    margin: 0 0 1rem 0;
  }

  figcaption {
    /* Undo some boilerplate from BGA */
    color: unset;
    margin: unset;
    line-height: unset;
    font-family: unset;
  }

  .sources {
    margin: 0.5em 0 0 0;
    font: 0.8em/1.3em var(--fonts-sans);
    color: var(--color-text);
  }
</style>
